"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HitRequestBuilder = void 0;
var HitRequestBuilder = /** @class */ (function () {
    function HitRequestBuilder() {
    }
    HitRequestBuilder.Address = {
        street: null,
        line1: null,
        line2: null,
        zip: null,
        city: null,
        state: null,
        country: null,
        type: null,
        timezone: null
    };
    HitRequestBuilder.responseQuery = {
        payload: {
            result: null
        }
    };
    HitRequestBuilder.FamilyCondition = {
        member: null,
        condition: null,
        type: null,
        typeBreastCancerDetails: null,
        ageAtOnset: null,
        wasCauseOfDeath: null,
        wasCauseOfDeathStr: null,
        memberLiving: null,
        memberAge: null,
        memberDiedAt: null
    };
    HitRequestBuilder.FamilyHistory = {
        motherLiving: null,
        motherDiedAt: null,
        motherDiedOf: null,
        fatherLiving: null,
        fatherDiedAt: null,
        fatherDiedOf: null,
        brothersLiving: null,
        sistersLiving: null,
        hasConditions: null,
        hadSeriousCondition: null,
        hadSeriousConditionDetails: null,
        hadSeriousConditionAndOrCancer: null,
        motherAge: null,
        fatherAge: null,
        familyConditions: [__assign({}, HitRequestBuilder.FamilyCondition)],
        hadHeritableCondition: null,
        hadHeritableConditionDetails: null
    };
    HitRequestBuilder.Surgery = {
        type: null,
        description: null,
        physician: null,
        date: null,
        city: null,
        state: null,
        details: null
    };
    HitRequestBuilder.RX = {
        rxName: null,
        type: null
    };
    HitRequestBuilder.Diagnosis = {
        type: null,
        description: null,
        physician: null,
        date: null,
        city: null,
        state: null,
        diagnosisDetails: null
    };
    HitRequestBuilder.DiagnosisShort = {
        physician: null,
        date: null,
        state: null,
        city: null,
        diagnosis: null,
        duration: null,
        diagnosisDetails: null
    };
    //missed in use? 'mvSuspendedOrDUI' should be cleaned from graphql/ServiceApiTypes
    HitRequestBuilder.PersonalHistory = {
        hadBDAutism: null,
        hadDBCerebralPalsy: null,
        hadHCHypertensionCurrent: null,
        hadDBDownSyndrome: null,
        hasTBIMultiple: null,
        hadEOHospitalizedLast10Years: null,
        hadEODiagnosisPeriod: null,
        hasRDCPAPWeeklyFrequency: null,
        hasRDCPAPNightlyHours: null,
        noTreatmentsNeeded: null,
        primaryPhysician: null,
        primaryPhysicianName: null,
        primaryPhysicianCity: null,
        primaryPhysicianState: null,
        procedure4HIVTest: null,
        primaryPhysicianPhone: null,
        primaryPhysicianLastVisitWhen: null,
        hadHeartCondition: null,
        hadHCAttack: null,
        hadHCAbnormalBeat: null,
        hadHCABFibrillation: null,
        hadHCABFTreatment: null,
        hadHCABFTFainted: null,
        hadHCHypertension: null,
        hadHCHMedication: null,
        bpMeasurements: null,
        systolic: null,
        diastolic: null,
        hadHCMurmur: null,
        hadHCMAdviseECG: null,
        hadHCMAdviseSurgery: null,
        hadHCMAdviseMeds: null,
        hadHCPericarditis: null,
        hadHCPMultipleEpisodes: null,
        hadHCPFullyRecovered: null,
        hadHCBenign: null,
        hadHCOther: null,
        hadHighCholesterol: null,
        hasMedicationCholesterol: null,
        hadHCElevatedNow: null,
        hadHCKnowLevels: null,
        hadHCAorticAneurysm: null,
        hadHCChestPains: null,
        hadCncrTesticular: null,
        hadHCPeripheralArteryVeinDisease: null,
        cholesterolTotal: null,
        cholesterolHDL: null,
        hadCancer: null,
        hadLeukemia: null,
        hadLymphoma: null,
        hadSkinCncrMelanoma: null,
        hadSkinCncrOther: null,
        hadCncrBreast: null,
        hadCncrBrain: null,
        hadCncrColon: null,
        hadCncrOvarian: null,
        hadCncrProstate: null,
        hadCncrRenal: null,
        hadCholestOther: null,
        hadBloodDisorder: null,
        hadBDAnemia: null,
        hadBDAnemiaType: null,
        hasBDAnemiaResolved: null,
        hadBDAnemiaBleeding: null,
        hasBDAnemiaControlled: null,
        hasBDAnemiaSymptoms: null,
        hadBDSpleen: null,
        hadBDClotting: null,
        hadBDHemochromatosis: null,
        hadBDOther: null,
        hadBrainDisorder: null,
        hadBDAneurysm: null,
        hadDBTumor: null,
        hadDBEncephalitits: null,
        hasDBRecovered: null,
        hasDBRecovered2Years: null,
        hadDBSeizures: null,
        medsDBSeizures: null,
        hadDBSiezuresLast5Years: null,
        hadDBMigranes: null,
        hadDBMDisabilityPayments: null,
        hadDBMS: null,
        hadDBNeuropathy: null,
        hadDBParkinsons: null,
        hadDBSciatica: null,
        hadDBStroke: null,
        hadDBFainting: null,
        hadDBFMultipleEpisodes: null,
        hadDBFLastYear: null,
        hadDBTIA: null,
        hadDBHematoma: null,
        hadDBTBI: null,
        hadDBTBILast5Years: null,
        hasTBISymptomsOrMeds: null,
        hadTBTourettes: null,
        hadTBNotSure: null,
        hadSeriousRespiratoryDisorder: null,
        hadCirrhosis: null,
        hadEmotionalDisorder: null,
        hadEOPsychosis: null,
        hadEOPsychosisHospitalizedLast10Years: null,
        hadEOHospitalizedLast5Years: null,
        hadEOAlcoholism: null,
        hadEOADepression: null,
        hadEOADepressionHospitalizedLast10Years: null,
        hadEOTreatment: null,
        hadChangeDoseEOTreatment: null,
        hadChangeDoseEOATreatmentOther: null,
        hadEODepressionSituationalOnly: null,
        hadEODepressionSocialSituational: null,
        hadEOHeartPalpitations: null,
        hadEODiagnosisDate: null,
        hadCare4EOHeartPalpitations: null,
        hadEOADHD: null,
        hadEOADHDChildhood: null,
        hadEO: null,
        hadEODelusion: null,
        hadEODrugCounseling: null,
        hadEOEatingDisorder: null,
        hadEOMajorDepression: null,
        hadEOPanicAttack: null,
        hadEOPAMedsLast2Years: null,
        hadEOSuicideAttempt: null,
        hadEOSuicideAttemptHospitalizedLast10Years: null,
        hadEOMinorDisorders: null,
        hadEONotSure: null,
        hadEENT: null,
        hadEENTAcousicNeuroma: null,
        hadEENTLeukoplakia: null,
        hadEENTOpticNeuritis: null,
        hadEENTNotSure: null,
        hadRespiratoryDisorder: null,
        hadRDSarcoidosis: null,
        hadRDCOPD: null,
        hadRDEmphysema: null,
        hadRDAsthma: null,
        hadRDAsthmaSymptomsFrequently: null,
        hadRDAHospitalizedLast1Year: null,
        hasRDApneaTreated: null,
        numberHospitalizationsRDAsthmaRelated: null,
        lastRDAsthmaHospitalization: null,
        hadRDAERLast1Year: null,
        hadRDAERLast1YearNumberOfTimes: null,
        hasRDAMeds: null,
        howManyRDAMeds: null,
        hasRDAMedsNow: null,
        hadRDPulmonaryNodule: null,
        hasRDApnea: null,
        hasRDCPAP: null,
        hasRDCPAPLast6Months: null,
        hasRDBronchitis: null,
        hasRDBRecovered: null,
        hadRDPneumonia: null,
        hasRDPRecovered: null,
        hadRDTuberculosis: null,
        hasRDTRecovered: null,
        medications: null,
        hadRDInfluenza: null,
        hadRDOther: null,
        hadDigestiveDisorder: null,
        hadDDAnorectalFistula: null,
        hadDDCeliacDisease: null,
        hadDDColonPolyp: null,
        hasMedicationCeliacDisease: null,
        hadDDChrons: null,
        hadDDColitusNonUlcerative: null,
        hadDDColitusUlcerative: null,
        hadDDiverticulitis: null,
        hadDDDLast6Months: null,
        hadDDNAFLD: null,
        hadDDLiverBiopsy: null,
        hadDDGastritis: null,
        hadDDHepititis: null,
        hadDDPancreaticInflamation: null,
        hadDDPancreatitis: null,
        hadDDUlcer: null,
        hadDDURecovered: null,
        hadDDWeightLossSurgery: null,
        hadDDBenign: null,
        hadBDNotSure: null,
        hadBoneMuscularDisorder: null,
        hadBMDAmputationsFromTrauma: null,
        hadBMDArthritis: null,
        hadBMDAType: null,
        hasBMDMeds: null,
        hasBMDDisabilityBenefits: null,
        hasBMDOsteoporosis: null,
        hasBMDBackPain: null,
        hasBMDBPMeds: null,
        hasMedicationBMDBackPain: null,
        hasBMDPagets: null,
        hasBMDBenign: null,
        hasBMDOther: null,
        hadRhumatologicDisorder: null,
        hadRDChronicFatigue: null,
        hasRDCFFunctionNormal: null,
        hadRDDepression: null,
        hadRDEpsteinBarr: null,
        hadRDEBOtherSymptoms: null,
        hadRDLupus: null,
        hadRDLymeDisease: null,
        hadRDLDSymptoms: null,
        hasRDLDTreatment: null,
        hasRDOther: null,
        hasDiabetesThyroid: null,
        hasMedicationHypothyroid: null,
        hasBiopsyThyroid: null,
        hasHypothyroid: null,
        hasDTDiabetes: null,
        hasDTDType: null,
        hasPregnancyGestational: null,
        hasDTProlactinoma: null,
        hasDTThyroidDisease: null,
        hasDTTStable: null,
        hasDTTImageBiopsy: null,
        hasDTNotSure: null,
        hadUrninaryTrackDisorder: null,
        hadUrninaryTrackDisorderDialysis: null,
        hadNephritisLast2Years: null,
        hadNephritisMoreThanLast2Years: null,
        hadUTDBladderStones: null,
        hadUTDGlomerulonephiritis: null,
        hadUTDKidneyStones: null,
        hadUTDKidneyStonesMultiple: null,
        hasUTDNormalKidney: null,
        hadUTDRenalFailure: null,
        hadUTDPyelonephiritis: null,
        hadUTStructural: null,
        hadUTDKidneyRecovered3Months: null,
        hadUTDProteinuria: null,
        hadUTDRenalCyst: null,
        hadUTDRCMultiple: null,
        hadUTDBenign: null,
        hadUTDNotSure: null,
        hadSkinDisorder: null,
        hadSDPsoriasis: null,
        hasEczema: null,
        hadSDArthritis: null,
        hasSDMeds: null,
        hasSDOther: null,
        hadImmunoDeficiency: null,
        hadIDReproductive: null,
        hadIDCervicitis: null,
        hadAbnormalUterineBleeding: null,
        hadIDFibrocystic: null,
        hadIDOvarianCyst: null,
        hadIDOBenign: null,
        hadIDPolycystic: null,
        hadIDCongenitalMalform: null,
        hadIDNotSure: null,
        hadComplicatedPregnancy: null,
        hadCPBenign: null,
        hadCPHighBloodPressure: null,
        hadCPHeartLiverKidneyProblems: null,
        hadCPSeizures: null,
        hadCPGestationalDiabities: null,
        hadCPNotSure: null,
        hadNoCondition: null,
        hadDrugUse: null,
        hadAlcoholAbuse: null,
        hadBloodTransfusion: null,
        hadHeartSurgery: null,
        hasProstatectomy: null,
        hadMastectomy: null,
        hadECG: null,
        hadECGNormal: null,
        hadECGCheckup: null,
        hadInsuranceRestricted: null,
        hadDisabilityClaim: null,
        hadNoECGDL: null,
        hadExamOther: null,
        hadEORoutine: null,
        hadEORoutineDetails: null,
        hadFullDiagnosisExclHIV: null,
        hadTreatmentOther: null,
        hadRXOther: null,
        medicalConditionCount: null,
        primaryPhysicianLastVisit: null,
        hadNotCompletedTest: null,
        toldHighBPCholest: null,
        hadDrugsNotPreferred: null,
        hadBeenHospitalized: null,
        hadAlcoholRehab: null,
        hadHIVTreatmentAdvice: null,
        hadHIVDiagnosed: null,
        hadCancerOrSyndrome: null,
        hadCancerOrDiabetes: null,
        haveNeitherHighBPCholest: null,
        primaryPhysicianRoutine: null,
        primaryPhysicianNotRoutineDetails: null,
        hivPositiveWhichAddress: null,
        hadBloodClotDisorderOrCoagulationDefects: null,
        hadCPHELLP: null,
        hadCPPreclampsia: null,
        hadDisabilityClaimDetails: null,
        hadDrugUseDetails: null,
        hadEOADepression6MonthsSymptomsControlled: null,
        hadEOADepressionDiagnosisDate: null,
        hadEOADepressionDoctorLastVisitWhen: null,
        hadEOADepressionTreatmentStr: null,
        hadEOADepressionTreatmentDoctor: null,
        hadEOADepressionType: null,
        hadEOBipolar: null,
        hadEOBipolarHospitalizedLast10YearsStr: null,
        hadEODelusionHospitalizedLast10Years: null,
        hadEOEatingDisorderHospitalizedLast10Years: null,
        hadEOOCD: null,
        hadEOOCDHospitalizedLast10YearsStr: null,
        hadEOPTSD: null,
        hadEOPTSDHospitalizedLast10YearsStr: null,
        hadInsuranceRestrictedDetails: null,
        hadMGUS: null,
        hadMyeloma: null,
        hadNonAnemiaDeficiencyOrBloodDisorder: null,
        hadUTDElevatedPSA: null,
        hadUTDInterstitialCystitis: null,
        hadKidneyCondition: null,
        hadKidneyOrBrainConditionOther: null,
        hadTerminalIllness: null,
        hadHCMurmurInLastYears: null,
        hadLeukemiaOrLymphoma: null,
        hadLeukemiaOrLymphomaInLastYears: null,
        hadSkinCncrMelanomaInLastYears: null,
        hadBDAnemiaInLastYears: null,
        hadDBOther: null,
        hadDBMSorCerebralPalsy: null,
        hadDBMSorCerebralPalsyInLastYears: null,
        hadDBSciaticaInLastYears: null,
        hadDBStrokeOrTransientIschemicAttack: null,
        hadDBStrokeOrTransientIschemicAttackInLastYears: null,
        hadRDAsthmaInLastYears: null,
        hadRDAsthmaHospitalization: null,
        hadRDAsthmaHospitalizationInLastYears: null,
        hasRDApneaInLastYears: null,
        hadDDiverticulitisInLastYears: null,
        hadDDHepatitisInLastYears: null,
        hadRDChronicFatigueOrFibromyalgia: null,
        hadRDChronicFatigueOrFibromyalgiaInLastYears: null,
        hadRDEpsteinBarrInLastYears: null,
        hadRDLupusInLastYears: null,
        hadRDLymeDiseaseInLastYears: null,
        hadUTDKidneyDialysis: null,
        hadUTDKidneyDialysisInLastYears: null,
        hadSDPsoriasisInLastYears: null,
        hadComplicatedPregnancyExclMiscCS: null,
        hadComplicatedPregnancyExclMiscCSInLastYears: null,
        hadCPHighBloodPressureInLastYears: null,
        hadSDArthritisInLastYears: null,
        hasRDBronchitisOrFibrosis: null,
        hasRDBronchitisOrFibrosisInLastYears: null,
        hadDBMigranesInLastYears: null,
        hadDBDegenerativeDiskDisease: null,
        hadDBDegenerativeDiskDiseaseInLastYears: null,
        hadAlcoholDrugAbuseTreatment: null,
        hadAlcoholDrugAbuseTreatmentInLastYears: null,
        hadHCABFibrillationInLastYears: null,
        hadDDHepatitisChronic: null,
        hadDDHepatitisChronicInLastYears: null,
        hadDDHepatitisRecovered6Months: null,
        hadDrugUseInLastYears: null,
        hadImmuneDeficiencyHIVorAIDS: null,
        hadImmuneDeficiencyHIVorAIDSInLastYears: null,
        hadEENTMacularDegenOpticNeuritis: null,
        hadEENTMacularDegenOpticNeuritisInLastYears: null,
        hadEmotionalDisorderInLastYears: null,
        hadSDNonRheumatoidArthritis: null,
        hadSDNonRheumatoidArthritisInLastYears: null,
        hadEOOCDinLastYears: null,
        hadTreatmentOtherInLastYears: null,
        hadDBParalysis: null,
        hadDBParalysisInLastYears: null,
        hadPartialCompleteHearingLoss: null,
        hadPartialCompleteHearingLossInLastYears: null,
        hadPartialCompleteSpeechLoss: null,
        hadPartialCompleteSpeechLossInLastYears: null,
        hadPartialCompleteVisionLoss: null,
        hadPartialCompleteVisionLossInLastYears: null,
        hadEOPTSDinLastYears: null,
        hadType1Diabetes: null,
        hadType1DiabetesInLastYears: null,
        hadType2Diabetes: null,
        hadType2DiabetesInLastYears: null,
        hadDDUlcerativeColitisCrohnsCD: null,
        hadDDUlcerativeColitisCrohnsCDInLastYears: null,
        hadDDiverticulitisMoreThan1Episode: null,
        hadDDiverticulitisMoreThan1EpisodeInLastYears: null,
        hadType2DiabetesDiabeticCompl: null,
        hadType2DiabetesDiabeticComplInLastYears: null,
        hadDBSeizuresInLastYears: null,
        hadDisabilityClaimInLastYears: null,
        hadInsuranceDeclinedRestricted: null,
        hadInsuranceDeclinedRestrictedInLastYears: null,
        hadHIVTreatmentAdviceDiagnosis: __assign({}, HitRequestBuilder.Diagnosis),
        hadHCAttackDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadHCAbnormalBeatDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadHCHMedicationDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadHCMurmurDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadHCPericarditisDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadCancerDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hasBDAnemiaResolvedDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadBDAnemiaBleedingDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hasBDAnemiaControlledDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hasBDAnemiaSymptomsDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadBDSpleenDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadBDClottingDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadBDHemochromatosisDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadChangeDoseEOATreatmentDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadHCAorticAneurysmDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadHCChestPainsDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadCncrTesticularDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadHCPeripheralArteryVeinDiseaseDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadBDAneurysmDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadBDAutismDetails: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadDBCerebralPalsyDetails: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadDBDownSyndromeDetails: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadDBTumorDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadDBEncephalititsDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadDBSeizuresDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadDBMDisabilityPaymentsDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadDBMSDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadDBNeuropathyDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadDBParkinsonsDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadDBStrokeDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadDBFMultipleEpisodesDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadDBFLastYearDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadDBTIADiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadDBHematomaDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hasTBISymptomsOrMedsDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadEOHospitalizedLast5YearsDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadEOAlcoholismDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadEOADepressionDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadEODiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadEODelusionDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadEODrugCounselingDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadEOEatingDisorderDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadEOMajorDepressionDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadEOPAMedsLast2YearsDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadEOSuicideAttemptDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadEENTAcousicNeuromaDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadEENTLeukoplakiaDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadEENTOpticNeuritisDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadRDSarcoidosisDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadRDCOPDDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadRDEmphysemaDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadRDAHospitalizedLast1YearDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadRDAERLast1YearDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hasRDAMedsDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadRDPulmonaryNoduleDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hasRDApneaDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hasRDPRecoveredDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadRDTuberculosisDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadDDCeliacDiseaseDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadDDColonPolypDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadDDChronsDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadDDColitusNonUlcerativeDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadDDColitusUlcerativeDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadDDDLast6MonthsDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadDDNAFLDDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadDDHepititisDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadDDPancreaticInflamationDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadDDPancreatitisDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadDDURecoveredDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadDDWeightLossSurgeryDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadBMDAmputationsFromTraumaDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadBMDATypeDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hasBMDMedsDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hasBMDDisabilityBenefitsDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hasBMDOsteoporosisDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hasBMDPagetsDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadRDChronicFatigueDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadRDEBOtherSymptomsDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadRDLupusDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadRDLymeDiseaseDetails: __assign({}, HitRequestBuilder.DiagnosisShort),
        diabetesDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hasDTProlactinomaDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hasDTTStableDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hasDTTImageBiopsyDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadNephritisLast2YearsDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadNephritisMoreThanLast2YearsDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadUTDGlomerulonephiritisDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hasUTDNormalKidneyDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadUTDRenalFailureDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadUTStructuralDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadUTDProteinuriaDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadUTDRCMultipleDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadSDArthritisDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hasSDMedsDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadIDOBenignDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadIDPolycysticDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadCPHeartLiverKidneyProblemsDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadCPSeizuresDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadCPGestationalDiabitiesDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadAlcoholAbuseDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadECGNormalDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadTreatmentOtherDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadLeukemiaDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadLymphomaDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadSkinCncrMelanomaDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadCncrBreastDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadCncrBrainDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadCncrColonDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadCncrOvarianDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadCncrProstateDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadCncrRenalDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadSkinCncrOtherDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadBDAnemiaDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hasBMDBackPainMedsDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hasHypothyroidDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadUrninaryTrackDisorderDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hasRDBRecoveredDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadFullTestExclHIVDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadDDAnorectalFistulaDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadDDGastritisDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadDDBenignDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadNotCompletedTestDiagnosis: __assign({}, HitRequestBuilder.Diagnosis),
        disabledDetails: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadBloodClotOrCoagulationDefectsDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadEOPsychosisHospitalizedDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadCPHELLPDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadCPPreclampsiaDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadEOADepressionHospitalizedDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadEOADepressionOther: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadEOBipolarHospitalizedDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadEODelusionHospitalizedLast10YearsDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadEODepressionSocialSituationalDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadEOEatingDisorderHospitalizedDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadEOOCDHospitalizedLast10YearsDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadEOPTSDHospitalizedLast10YearsDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadIDCervicitisDiagnosisDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadAbnormalUterineBleedingDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadImmunoDeficiencyDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadMGUSDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadMyelemoDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadUTDElevatedPSADiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadUTDInterstitialCystitisDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadHCOtherDiagnosis: [__assign({}, HitRequestBuilder.Diagnosis)],
        otherDiagnosisis: [__assign({}, HitRequestBuilder.Diagnosis)],
        hadCholestOtherDiagnosis: [__assign({}, HitRequestBuilder.Diagnosis)],
        diagnosisTB: [__assign({}, HitRequestBuilder.Diagnosis)],
        diagnosisEONotSure: [__assign({}, HitRequestBuilder.Diagnosis)],
        diagnosisEENTNotSure: [__assign({}, HitRequestBuilder.Diagnosis)],
        diagnosisRDOther: [__assign({}, HitRequestBuilder.Diagnosis)],
        diagnosisDDOther: [__assign({}, HitRequestBuilder.Diagnosis)],
        diagosisBMDAOther: [__assign({}, HitRequestBuilder.Diagnosis)],
        diagnosisRMDOther: [__assign({}, HitRequestBuilder.Diagnosis)],
        DiagnosisisDTNotSure: [__assign({}, HitRequestBuilder.Diagnosis)],
        DiagnosisUTDNotSure: [__assign({}, HitRequestBuilder.Diagnosis)],
        DiagnosisSDNotSure: [__assign({}, HitRequestBuilder.Diagnosis)],
        DiagnosisIDNotSure: [__assign({}, HitRequestBuilder.Diagnosis)],
        CPDetails: [__assign({}, HitRequestBuilder.Diagnosis)],
        bloodTransfusionDetails: [__assign({}, HitRequestBuilder.Surgery)],
        otherSurgeryDetails: [__assign({}, HitRequestBuilder.Surgery)],
        heartSurgeryDetails: [__assign({}, HitRequestBuilder.Surgery)],
        medsHCH: [__assign({}, HitRequestBuilder.RX)],
        hadMedsOther: [__assign({}, HitRequestBuilder.RX)],
        medsHCCholesterol: [__assign({}, HitRequestBuilder.RX)],
        medsEOADepression: [__assign({}, HitRequestBuilder.RX)],
        medsRDAsthma: [__assign({}, HitRequestBuilder.RX)],
        hadTreatmentOtherDiagnosisCollection: [__assign({}, HitRequestBuilder.Diagnosis)],
        hadEOADepressionHospitalizedDetails: null,
        hadChangeDoseEOATreatmentDetails: null,
        hadEODepressionSocialSituationalDetails: null,
        hadRDAER: null,
        hasDTDiabetesInsulin: null,
        hasDTDiabetesComplications: null,
        hadRheumaticDisorderTreatment: null
    };
    HitRequestBuilder.ExistingPolicy = {
        companyName: null,
        otherCompanyName: null,
        number: null,
        face: null,
        type: null,
        issueYear: null,
        purpose: null,
        status: null,
        isPolicyOwner: null,
        isReplacement: null,
        isReplacementFunds: null,
        owner: null,
        insured: null,
        ownerName: null,
        insuredName: null,
        replacementValue: null,
        replacementLoanAmount: null,
        replacementPurpose: null,
        reimburseMethod: null,
        coverageStartDate: null,
        premium: null,
        paymentFrequency: null,
        pendingCoverageIntent: null,
        isGroupPolicy: null
    };
    HitRequestBuilder.ExistingPolicyApplying = Object.assign({}, HitRequestBuilder.ExistingPolicy);
    HitRequestBuilder.ExistingPolicyInForce = Object.assign({}, HitRequestBuilder.ExistingPolicy);
    HitRequestBuilder.ExistingPolicyQuery = {
        _on: {
            ExistingPolicy: __assign({}, HitRequestBuilder.ExistingPolicy),
            ExistingPolicyApplying: __assign({}, HitRequestBuilder.ExistingPolicyApplying),
            ExistingPolicyInForce: __assign({}, HitRequestBuilder.ExistingPolicyInForce)
        }
    };
    HitRequestBuilder.ExistingPolicies = {
        existingPolicyList: [__assign({}, HitRequestBuilder.ExistingPolicyQuery)],
        replaceInforceApplication: null,
        hasExistingPolicies: null,
        needMoreCoverage: null,
        purchaseFaceAmount: null,
        hasExistingInforcePolicies: null,
        inForcePoliciesFaceTotal: null,
        isReplacementOther: null,
        groupCoverageInForce: null,
        groupCoverageAppliedFor: null,
        nonGroupCoverageInForce: null,
        nonGroupCoverageAppliedFor: null,
        isApplyingForPolicy: null,
        existingApplicationList: [__assign({}, HitRequestBuilder.ExistingPolicyQuery)],
        existingInForcePolicyList: [__assign({}, HitRequestBuilder.ExistingPolicyQuery)]
    };
    HitRequestBuilder.OccupationFactors = {
        liftHeavy50: null,
        liftOften25: null,
        crouch: null,
        repetitiveMotions: null,
        extremeClimate: null,
        hazards: null,
        liftHeavy50Frequency: null,
        liftOften25Frequency: null,
        crouchFrequency: null,
        repetitiveMotionsFrequency: null,
        extremeClimateFrequency: null,
        hazardsFrequency: null,
        particleExposureFrequency: null,
        driveExtensivelyFrequency: null,
    };
    HitRequestBuilder.Avocation = {
        type: null,
        frequency: null,
        details: null,
        customer_id: null
    };
    HitRequestBuilder.Bankruptcy = {
        bankruptcyType: null,
        bankruptcyTypeOther: null,
        dischargedDate: null,
        notDischarged: null
    };
    HitRequestBuilder.AccidentAtFault = {
        mvAccidentWhen: null
    };
    HitRequestBuilder.SpeedingTicket = {
        mvSpeeding15Over: null,
        mvSpeedingDate: null
    };
    HitRequestBuilder.RecklessTicket = {
        mvRecklessDate: null
    };
    HitRequestBuilder.OtherMovingViolation = {
        mvOtherWhen: null,
        mvOtherDetails: null
    };
    HitRequestBuilder.DrivingWhileSuspendedCon = {
        mvDWSConvictionDate: null,
        mvLicenseSuspendedDetails: null
    };
    HitRequestBuilder.DUIConviction = {
        mvDUIDate: null
    };
    HitRequestBuilder.TravelCountry = {
        name: null,
        ftOtherCountry: null,
        ftMexicoSpecific: null,
        ftMexicoSpecificOther: null,
        departureDateWhen: null,
        departureDate: null,
        departureDateNY: null,
        noDepartureDateNY: null,
        duration: null,
        purpose: null,
        purposeDetails: null
    };
    HitRequestBuilder.BigGameCountry = {
        name: null
    };
    HitRequestBuilder.RiskFactors = {
        occupationFactors: __assign({}, HitRequestBuilder.OccupationFactors),
        avOtherDetail: [__assign({}, HitRequestBuilder.Avocation)],
        mvAccidentAtFaults: [__assign({}, HitRequestBuilder.AccidentAtFault)],
        mvDUIConvictions: [__assign({}, HitRequestBuilder.DUIConviction)],
        mySpeedingTickets: [__assign({}, HitRequestBuilder.SpeedingTicket)],
        mbRecklessTickets: [__assign({}, HitRequestBuilder.RecklessTicket)],
        mvOthers: [__assign({}, HitRequestBuilder.OtherMovingViolation)],
        mvDrivingWhileSuspendedCons: [__assign({}, HitRequestBuilder.DrivingWhileSuspendedCon)],
        ftCountries: [__assign({}, HitRequestBuilder.TravelCountry)],
        avBigGameCountries: [__assign({}, HitRequestBuilder.BigGameCountry)],
        armedForces: null,
        medicalDischarge: null,
        isFelonios: null,
        isFeloniosDetails: null,
        isPilot: null,
        lastFlightDate: null,
        pilot: null,
        pilotCategory: null,
        pilotTotalHrs: null,
        pilotLast12MonthsHrs: null,
        pilotNext12MonthsHrs: null,
        pilotTotalHrsPastFuture: null,
        crewMemberTitle: null,
        crewMemberLast12MonthsHrs: null,
        crewMemberNext12MonthsHrs: null,
        flyWithinUS: null,
        flyOutsideUSDetails: null,
        licenseType: null,
        ratingType: null,
        ratingOther: null,
        flyMakeModel: null,
        flySolo: null,
        flySoloDetails: null,
        flyType: null,
        flyTypePersonal: null,
        flyTypeAirTaxi: null,
        flyTypeTest: null,
        flyTypeScheduled: null,
        flyTypeCompany: null,
        flyTypeHire: null,
        flyTypeCharters: null,
        flyTypeProd: null,
        flyTypeCargo: null,
        flyTypeInstructor: null,
        flyTypeSupplemental: null,
        flyTypeDusting: null,
        flyTypeOtherAirlines: null,
        flyTypeSeeding: null,
        flyTypeOther: null,
        flyTypeOtherStr: null,
        flyAircraftTypeSingle: null,
        flyAircraftTypePropeller: null,
        flyAircraftTypeSingleHelicopter: null,
        flyAircraftTypeSingleSailplane: null,
        flyAircraftTypeHotAirBallon: null,
        flyAircraftTypeGas: null,
        flyAircraftTypeMulti: null,
        flyAircraftTypeJet: null,
        flyAircraftTypeBomber: null,
        flyAircraftTypeFighter: null,
        flyAircraftTypeTransport: null,
        flyAircraftUltralightSoarding: null,
        flyAircraftTypeGlider: null,
        flyAircraftTypeHomeBuilt: null,
        flyAircraftTypeHomeBuiltDetails: null,
        flyAircraftTypeReconOrLiaison: null,
        flyAircraftTypeExperimental: null,
        flyAircraftTypeOther: null,
        flyAircraftTypeOtherDetails: null,
        militaryServiceBranch: null,
        militaryRank: null,
        militaryDuties: null,
        militaryDutiesOther: null,
        militaryFlyCarrier: null,
        militaryFlyCarrierDetails: null,
        militaryFlyAircraftTypeSingle: null,
        militaryFlyAircraftTypePropeller: null,
        militaryFlyAircraftTypeHelicopter: null,
        militaryFlyAircraftTypeRecon: null,
        militaryFlyAircraftTypeTest: null,
        militaryFlyAircraftTypeTestDetails: null,
        militaryFlyAircraftTypeMulti: null,
        militaryFlyAircraftTypeJet: null,
        militaryFlyAircraftTypeBomber: null,
        militaryFlyAircraftTypeFighter: null,
        militaryFlyAircraftTypeUltralightSoaring: null,
        militaryFlyAircraftTypeTransport: null,
        militaryFlyAircraftTypeOther: null,
        militaryFlyAircraftTypeOtherDetails: null,
        militaryCapacity: null,
        militaryDetails: null,
        militaryDischargeDate: null,
        militaryHazardPay: null,
        militaryHazardPayDetails: null,
        militaryOutsideUS: null,
        militaryOutsideUSDetails: null,
        hasAvocations: null,
        avAutoRacing: null,
        avARATV: null,
        avARATV3Wheel: null,
        avARCrash: null,
        avARCDiveBomber: null,
        avARCDemolition: null,
        avARCOther: null,
        avARGoCart: null,
        avARGCSprint: null,
        avARGCEnduro: null,
        avARGCFormula: null,
        avARGCMidget: null,
        avARGCMini: null,
        avAROffRoad: null,
        avARORDesert: null,
        avARORRally: null,
        avAROROther: null,
        avAROROtherDetails: null,
        avARRally: null,
        avAROther: null,
        avAROtherDetails: null,
        avBalloning: null,
        avBigGame: null,
        avIsBigGameWithinUS: null,
        avBigGameType: null,
        avBobsledding: null,
        avBoxing: null,
        avBoxingPro: null,
        avBungee: null,
        avBungeeNow: null,
        avHangGliding: null,
        avHangGlidingLow: null,
        avHangGlidingOften: null,
        avHeliSkiing: null,
        avMartialArts: null,
        avMartialArtsPro: null,
        avSnowmobileRacing: null,
        avMotorboatRacing: null,
        avMotorcycleRacing: null,
        avMRType: null,
        avMRGrandPrix: null,
        avMRDrag: null,
        avMRDragDetails: null,
        avMountainClimbing: null,
        avMCRated: null,
        avMCRatedGym: null,
        avMCYDS: null,
        avMCNextYearTripNumber: null,
        avMCOvernight: null,
        avMCMaxElevation: null,
        avScubaDiving: null,
        avSDShallow: null,
        avSDBasicCert: null,
        avSDCert: null,
        avSDBuddy: null,
        avSDInfrequent: null,
        avSkyDiving: null,
        avSDSoon: null,
        avSKDInfrequent: null,
        avSDAmateur: null,
        avSDAmateurDetails: null,
        avUltralightSoaring: null,
        avOther: null,
        airborneSports: null,
        mountainSports: null,
        racings: null,
        martialArts: null,
        underwaterDiving: null,
        noSports: null,
        mvDUI: null,
        mvLastDUI: null,
        mvDUIConvitions: null,
        mvAccident: null,
        mvViolations: null,
        mvAccidentAtFault: null,
        mvSpeeding: null,
        mySpeedingTicketCount: null,
        mbReckless: null,
        mvOther: null,
        mvDrivingWhileSuspended: null,
        mvLicenseSuspended: null,
        mvLicenseSuspendedDetails: null,
        disabled: null,
        anticipatingForeignTravel: null,
        ftBenign: null,
        ftDuration: null,
        ftPurpose: null,
        ftWithFamily: null,
        ftWithFamilyDetails: null,
        isSmokester: null,
        isSmokerYear: null,
        usesCigarettes: null,
        usesCigars: null,
        usesCigarsCurrently: null,
        usesPipe: null,
        usesCigarsFrequency: null,
        quitCigarrettesPeriod: null,
        whenLastSmokedCigars: null,
        quitCigarsPeriod: null,
        usedCigarsFrequency: null,
        quitTobaccoPeriod: null,
        useTobaccoCessationMeds: null,
        useAlcohol: null,
        isPregnant: null,
        weightLoss: null,
        weightLossFromExcercise: null,
        weightLossFromDiet: null,
        hasWeightChangedBy10: null,
        howManyAlcohol: null,
        whenLastSmoked: null,
        yearsAgoLastSmoked: null,
        bingeDrinkingMonthly: null,
        medicalDischargeDetailsStr: null,
        disabledDetails: null,
        currUsesOtherTobacco: null,
        usesMarijuana: null,
        whenLastUsedMarijuana: null,
        recreationalOrMedicalMarijuanaUser: null,
        usesMarijuanaFrequency: null,
        medicinalMarijuanaCondition: null,
        useAlcoholBinge: null,
        whenLastSmokedCigarettes: null,
        whenLastSmokedOrUsedMarijuana: null,
        yearsAgoLastSmokedOrUsedMarijuana: null,
        dontDrinkAlcohol: null,
        mvSuspendedOrDUI: null,
        chargeType: null,
        chargeDate: null,
        chargeLocationDetails: null,
        sentenceType: null,
        jailPrisonReleaseDate: null,
        jailPrisonSentenceLength: null,
        probationNow: null,
        probationEndDate: null,
        flySoloTotalHrs: null,
        avBungeeFuture: null,
        avBungeePast: null,
        mvNone: null,
        mvLicenseSuspendedPast: null,
        recentlyDisabled: null,
        disabledCause: null,
        disabledRecoveryDate: null,
        disabledStartDate: null,
        medicinalMarijuanaDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        medicalDischargeDetails: __assign({}, HitRequestBuilder.DiagnosisShort),
        hashimotoDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hasCurrentHBPressure: null,
        hasCurrentElevatedCholesterol: null,
        isPregnantHighRisk: null,
        pregnancyHighRiskDetails: __assign({}, HitRequestBuilder.DiagnosisShort),
        limit2CigarsPerMonth: null,
    };
    HitRequestBuilder.Phone = {
        bucket: null,
        number: null,
        type: null,
        country: null
    };
    //missed in use? 'insuredIncome'
    HitRequestBuilder.Financials = {
        employed: null,
        employmentStatus: null,
        employmentStatusDetails: null,
        isHomeMaker: null,
        coverageExistingAmt: null,
        noCoverageExistingAmt: null,
        unknownCoverageExistingAmt: null,
        employerName: null,
        annualIncome: null,
        annualHouseholdIncome: null,
        graduationDate: null,
        fieldOfStudy: null,
        educationLevel: null,
        otherIncome: null,
        totalAssets: null,
        totalLiabilities: null,
        netWorth: null,
        isNotFATCAWitholding: null,
        isFATCAResidencyStatus: null,
        occupation: null,
        occupationTranslated: null,
        occupationCode: null,
        duties: null,
        unemploymentDuration: null,
        unemploymentDurationMonths: null,
        priorOccupation: null,
        priorIncome: null,
        reemploymentExpectancy: null,
        reemploymentExpectancyDetails: null,
        hasBankruptcyHistory: null,
        bankruptcyType: null,
        isBankruptcyDischarged: null,
        bankruptcyDischargeDate: null,
        workerType: null,
        industry: null,
        hoursWorkedPrimary: null,
        daysMissedWork: null,
        bankruptcies: [__assign({}, HitRequestBuilder.Bankruptcy)]
    };
    HitRequestBuilder.Party = {
        email: null,
        partyType: null,
        isAccountHolder: null,
        phone: __assign({}, HitRequestBuilder.Phone),
        mailingAddress: __assign({}, HitRequestBuilder.Address),
        businessAddress: __assign({}, HitRequestBuilder.Address),
        alternatePhone: __assign({}, HitRequestBuilder.Phone),
        legalAddress: __assign({}, HitRequestBuilder.Address),
        isTINCorrect: null,
        verificationAddress: __assign({}, HitRequestBuilder.Address),
        financials: __assign({}, HitRequestBuilder.Financials),
        existingPolicies: __assign({}, HitRequestBuilder.ExistingPolicies)
    };
    HitRequestBuilder.ResidentialAssetWithoutParty = {
        type: null,
        description: null,
        amount: null
    };
    HitRequestBuilder.PersonWithoutFamilyMembers = Object.assign({}, HitRequestBuilder.Party, {
        residentialAddress: __assign({}, HitRequestBuilder.Address),
        firstName: null,
        middleName: null,
        lastName: null,
        gender: null,
        SSN: null,
        EIN: null,
        age: null,
        dob: null,
        birthCity: null,
        birthCountry: null,
        birthState: null,
        hasDriversLicense: null,
        idType: null,
        idNumber: null,
        idOtherType: null,
        idCountry: null,
        idState: null,
        idExpires: null,
        idIssuedDate: null,
        residencyStatus: null,
        resiCatgdStatus: null,
        residencyDetail: null,
        visaType: null,
        residencyContinuous: null,
        residencyContinuousDetail: null,
        residencyYears: null,
        citizenshipCountry: null,
        childrenResident: null,
        parentResident: null,
        partnerResident: null,
        siblingResident: null,
        noResident: null,
        otherResident: null,
        residencyAsset: null,
        residencyAssetList: [__assign({}, HitRequestBuilder.ResidentialAssetWithoutParty)],
        residentialProperty: null,
        commercialProperty: null,
        investmentAccount: null,
        bankAccount: null,
        otherProperty: null,
        otherAssetProperty: null,
        assetValue: null,
        residencyPlans: null,
        residencyPlansDetails: null,
        residencyCountry: null,
        famAbsenceUSRes: null,
        absenceUsRes: null,
        outsideUSResidentialYears: null,
        resAbsencePurpose: null,
        resAbsenceMission: null,
        hasVisa: null,
        visaNumber: null,
        visaExpireDate: null,
        residentLeaveDate: null,
        documentationDetail: null,
        TIN: null,
        noSSN: null,
        noTIN: null,
        idIssuedDateDate: null,
        relationshipToInsured: null,
        documentationType: null,
        permanentResidentCardNumber: null,
        employmentAuthDocNumber: null,
        otherDocumentationType: null,
        otherDocNumber: null,
        documentationExpireDate: null
    });
    HitRequestBuilder.PartyRelation = {
        description: null,
        source: __assign({}, HitRequestBuilder.PersonWithoutFamilyMembers),
        target: __assign({}, HitRequestBuilder.PersonWithoutFamilyMembers)
    };
    HitRequestBuilder.Person = Object.assign({}, HitRequestBuilder.PersonWithoutFamilyMembers, {
        familyMembers: [__assign({}, HitRequestBuilder.PartyRelation)]
    });
    HitRequestBuilder.Signer = Object.assign({}, HitRequestBuilder.Person, {
        isLegalGuardian: null,
        isSoleOfficer: null,
        title: null
    });
    HitRequestBuilder.Trustee = {
        type: null,
        entityName: null,
        entityAuthorizedSigner: __assign({}, HitRequestBuilder.Signer),
        trusteePerson: __assign({}, HitRequestBuilder.Person),
        party: __assign({}, HitRequestBuilder.Party)
    };
    HitRequestBuilder.Grantor = {
        grantorPerson: __assign({}, HitRequestBuilder.Person),
        type: null,
        entityName: null,
        TIN: null,
        party: __assign({}, HitRequestBuilder.Party),
        taxId: null,
        taxIdType: null,
        noTaxId: null
    };
    //missed in use? 'noEIN'|'isForeignEntity'|'phoneNumber'|'ssnToggle'|'TIN'
    HitRequestBuilder.Entity = Object.assign({}, HitRequestBuilder.Party, {
        type: null,
        specificType: null,
        name: null,
        citizenship: null,
        taxId: null,
        ssnorein: null,
        trustSitus: null,
        formed: null,
        trustType: null,
        isDirectorOrHighlyCompensated: null,
        maxFaceAmt: null,
        trustName: null,
        trustDate: null,
        authorizedTrusteeList: [__assign({}, HitRequestBuilder.Trustee)],
        trustGrantorList: [__assign({}, HitRequestBuilder.Grantor)],
        relationshipAsBeneficiary: null,
        relationshipAsBeneficiaryDetails: null,
        relationshipAsGrantor: null,
        relationshipAsGrantorDetails: null,
        doesTrustAuthorizeTrustee: null,
        certifiedDocumentSignee: null,
        isAddressSameAsInsured: null,
        isMailingAddressSameAsLegal: null,
        isUSEntity: null,
        designatedTrusteeIndex: null,
        authorizedSignerFirstName: null,
        authorizedSignerMiddleName: null,
        authorizedSignerLastName: null,
        authorizedSignerEmail: null,
        authorizedSignerTitle: null,
        authorizedSigner: __assign({}, HitRequestBuilder.Signer),
        country: null,
        ownerAddress: __assign({}, HitRequestBuilder.Address),
        designatedTrustee: __assign({}, HitRequestBuilder.Trustee)
    });
    HitRequestBuilder.PartyQuery = {
        _on: {
            Person: __assign({}, HitRequestBuilder.Person),
            Entity: __assign({}, HitRequestBuilder.Entity)
        }
    };
    HitRequestBuilder.MedicalTreatment = {
        treatmentType: null,
        treatmentDesc: null,
        treatmentStatus: null,
        medication: null,
        dateLastSeen: null,
        timePeriod: null,
        recommendation: null,
        treatmentAmt: null,
        treatmentFrequencyMode: null,
        details: __assign({}, HitRequestBuilder.DiagnosisShort)
    };
    HitRequestBuilder.Cancer = {
        medicalTreatments: [__assign({}, HitRequestBuilder.MedicalTreatment)],
        cancerType: null,
        cancerTypeDesc: null,
        cancerStage: null,
        cancerSpreadInd: null,
        cancerSpreadDesc: null,
        numOccurrences: null,
        details: __assign({}, HitRequestBuilder.DiagnosisShort)
    };
    HitRequestBuilder.MedicalPrevention = {
        testType: null,
        testDate: null,
        recommendation: null,
        resultsType: null,
        resultsFindings: null,
        resultsDesc: null,
        testResultValue: null,
        testResultUnitOfMeasure: null,
        nextTestDate: null,
        timePeriod: null,
        followUpInd: null,
        visitReason: null,
        details: __assign({}, HitRequestBuilder.DiagnosisShort)
    };
    HitRequestBuilder.SubstanceUsage = {
        medicalTreatments: [__assign({}, HitRequestBuilder.MedicalTreatment)],
        substanceType: null,
        substanceDesc: null,
        substanceLastUsePeriod: null,
        substanceLastUseDate: null,
        substanceMode: null,
        substanceAmt: null,
        usageType: null,
        currentUsageInd: null,
        substanceLastUseDesc: null,
        relapseInd: null,
        lastRelapseDate: null,
        details: __assign({}, HitRequestBuilder.DiagnosisShort)
    };
    HitRequestBuilder.MedicalCondition = {
        cancers: [__assign({}, HitRequestBuilder.Cancer)],
        medicalTreatments: [__assign({}, HitRequestBuilder.MedicalTreatment)],
        medicalPreventions: [__assign({}, HitRequestBuilder.MedicalPrevention)],
        substanceUsages: [__assign({}, HitRequestBuilder.SubstanceUsage)],
        conditionType: null,
        conditionDescription: null,
        conditionStage: null,
        conditionStatus: null,
        cause: null,
        episodeInd: null,
        numberEpisodesTotal: null,
        lastEpisodeDate: null,
        symptomsInd: null,
        conditionComplications: null,
        weightChange: null,
        weightChangeUnits: null,
        activitiesImpacted: null,
        firstDiagnosisDate: null,
        conditionOnset: null,
        details: __assign({}, HitRequestBuilder.DiagnosisShort)
    };
    HitRequestBuilder.Risk = {
        medicalConditions: [__assign({}, HitRequestBuilder.MedicalCondition)],
        medicalTreatments: [__assign({}, HitRequestBuilder.MedicalTreatment)],
        medicalPreventions: [__assign({}, HitRequestBuilder.MedicalPrevention)],
        substanceUsages: [__assign({}, HitRequestBuilder.SubstanceUsage)],
    };
    HitRequestBuilder.DiagnosisExtra = {
        type: null,
        description: null,
        physician: null,
        date: null,
        city: null,
        state: null,
        diagnosisDetails: null
    };
    HitRequestBuilder.ChronicIllnessRiderSupplement = {
        requiresHygieneAid: null,
        hygieneAidDetails: null,
        requiresMachineAid: null,
        machineAidDetails: null,
        requiresChoreAid: null,
        choreAidDetails: null,
        hasAlzheimers: null,
        hasAlzheimersDetails: null,
        hasAls: null,
        hasAlsDetails: null,
        hasCerebralPalsy: null,
        hasCerebralPalsyDetails: null,
        hasCysticFibrosis: null,
        hasCysticFibrosisDetails: null,
        hasDementia: null,
        hasDementiaDetails: null,
        hasHuntingtons: null,
        hasHuntingtonsDetails: null,
        hasLiverCirrhosis: null,
        hasLiverCirrhosisDetails: null,
        hasMuscularDystrophy: null,
        hasMuscularDystrophyDetails: null,
        hasMyastheniaGravis: null,
        hasMyastheniaGravisDetails: null,
        hasBrainSyndrome: null,
        brainSyndromeDetails: null,
        hasParalysis: null,
        hasParalysisDetails: null,
        hasParkinsons: null,
        hasParkinsonsDetails: null,
        hasSchizophrenia: null,
        hasSchizophreniaDetails: null,
        hadAmnesia: null,
        amenesiaDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadBoneOrJointCondition: null,
        boneOrJointConditionDiagnosis: [__assign({}, HitRequestBuilder.DiagnosisExtra)],
        hadAtaxiaMyelitisNeuron: null,
        ataxiaMyelitisNeuronDiagnosis: [__assign({}, HitRequestBuilder.DiagnosisExtra)],
        hadLimitedMotion: null,
        limitedMotionDiagnosis: [__assign({}, HitRequestBuilder.DiagnosisExtra)],
        hadMemoryLoss: null,
        memoryLossDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadTremorsOrNumbness: null,
        tremorNumbDiagnosis: __assign({}, HitRequestBuilder.DiagnosisShort),
        hadFallLeadingToInjury: null,
        fallLeadingToInjuryDiagnosis: [__assign({}, HitRequestBuilder.DiagnosisExtra)],
        receivedDisabilityBenefits: null,
        coveredByMedicaid: null,
        cirRecentlyRejected: null,
        cirInForceCoverageAmount: null
    };
    HitRequestBuilder.Applicant = {
        party: __assign({}, HitRequestBuilder.PartyQuery),
        signer: __assign({}, HitRequestBuilder.Person),
        hasSigner: null,
        familyHistory: __assign({}, HitRequestBuilder.FamilyHistory),
        personalHistory: __assign({}, HitRequestBuilder.PersonalHistory),
        chronicIllnessRiderSupplement: __assign({}, HitRequestBuilder.ChronicIllnessRiderSupplement),
        risk: [__assign({}, HitRequestBuilder.Risk)],
        riskFactors: __assign({}, HitRequestBuilder.RiskFactors),
        existingPolicies: __assign({}, HitRequestBuilder.ExistingPolicies),
        financials: __assign({}, HitRequestBuilder.Financials),
        healthClass: null,
        weight: null,
        height: null,
        heightFeet: null,
        heightInches: null,
        hivSendTo: null,
        bloodPressureKnown: null,
        bloodPressureHigh: null,
        bloodPressureRange: null,
        bloodPressureSystolic: null,
        bloodPressureDystolic: null,
        bloodPressureMedicationUsed: null,
        bloodPressureTreatedPeriod: null,
        bloodPressureControlledPeriod: null,
        cholesterolKnown: null,
        cholesterolHigh: null,
        cholesterolLevel: null,
        cholesterolRange: null,
        cholesterolRatio: null,
        cholesterolMedicationUsed: null,
        cholesterolTreatedPeriod: null,
        cholesterolControlledPeriod: null,
        smoker: null,
        cigarettesUsed: null,
        cigarettesQuantity: null,
        cigarettesPeriodLastUsed: null,
        cigarsUsed: null,
        cigarsQuantity: null,
        cigarsPeriodLastUsed: null,
        pipeUsed: null,
        pipeQuantity: null,
        pipePeriodLastUsed: null,
        chewingTobaccoUsed: null,
        chewingTobaccoQuantity: null,
        chewingTobaccoPeriodLastUsed: null,
        nicotineGumUsed: null,
        nicotineGumQuantity: null,
        nicotineGumPeriodLastUsed: null,
        chronicCondition: null,
        overrideAmount: null,
        overrideTerm: null,
        policyHidden: null,
        policyAppliedFor: null,
        reapplyTokensLeft: null,
        applicantType: null
    };
    HitRequestBuilder.Beneficiary = {
        ratio: null,
        partyProperty: null,
        type: null,
        relationship: null,
        beneType: null,
        dob: null,
        fullName: null,
        financiallyImpacted: null,
        isMinor: null,
        party: __assign({}, HitRequestBuilder.PartyQuery)
    };
    HitRequestBuilder.CollateralAssignment = {
        assignee: __assign({}, HitRequestBuilder.Entity),
        loanPurpose: null,
        loanDuration: null,
        isSBALoan: null,
        loanRepaymentDetails: null,
        loanOfficerName: null,
        loanOfficerEmail: null
    };
    HitRequestBuilder.JointPolicy = {
        isPrimary: null,
        currentPolicyType: null,
        otherPolicyType: null,
        otherPolicyNumber: null,
        applicationId: null,
        otherPrimaryOrSecondary: null
    };
    HitRequestBuilder.BusinessPurposePartnersWithoutPolicyBusinessPurpose = {
        carryLifeInsuranceName: null,
        carryLifeInsuranceTitle: null,
        carryLifeInsuranceFaceAmount: null,
        carryLifeInsurancePercentOwned: null
    };
    HitRequestBuilder.PolicyBusinessPurpose = {
        isKeyEmployee: null,
        isBuyOrSell: null,
        hasLoanGuaranteeCoverage: null,
        hasDeferredCompensation: null,
        isSplitDollar: null,
        isTargetBenefitPlan: null,
        hasOther: null,
        reasonForBuyingPolicyDetails: null,
        name: null,
        type: null,
        yearEstablished: null,
        estimatedNetValue: null,
        numberOfEmployees: null,
        percentageOwned: null,
        totalAssets: null,
        totalLiabilities: null,
        totalNetWorth: null,
        marketValue: null,
        dateLastFormalValuation: null,
        netProfitBeforeTaxesCurrentYear: null,
        netProfitBeforeTaxesPrevYear: null,
        carryLifeInsurance: null,
        carryLifeInsuranceDetails: null,
        employeeSpecialSkills: null,
        writtenAgreement: null,
        agreementOriginationDate: null,
        employeeAdditionalDetails: null,
        businessPurposePartners: [__assign({}, HitRequestBuilder.BusinessPurposePartnersWithoutPolicyBusinessPurpose)]
    };
    HitRequestBuilder.Exchange1035 = {
        applyTowards: null,
        costBasis: null
    };
    HitRequestBuilder.PolicyRider = {
        type: null,
        amount: null,
        premiumBase: null,
        premiumWaiver: null,
        plannedYears: null,
        paymentFrequency: null,
        lumpSumAmount: null,
        exchangeAmount1035: null,
        purposeOf1035exchange: null,
        lumpSumUses1035: null,
        hasScheduledPayments: null,
        exchange1035: __assign({}, HitRequestBuilder.Exchange1035),
        benefitDisbursementMethod: null,
        predictedBenefitAge: null,
        puaAddedToBenefitPool: null,
        monthlyIncreaseOption: null,
    };
    //missed in use: 'premiumLoan'|'trustOrOtherEntity'|'includeAdbr'
    HitRequestBuilder.Policy = {
        owner: __assign({}, HitRequestBuilder.PartyQuery),
        otherOwner: __assign({}, HitRequestBuilder.Person),
        ownerCategory: null,
        insured: __assign({}, HitRequestBuilder.Applicant),
        policyNumber: '',
        type: null,
        carrier: null,
        product: null,
        productType: null,
        submittedLanguage: null,
        status: null,
        submittedAt: null,
        submittedFromIP: null,
        insuredType: null,
        ownerType: null,
        reasonForInsuranceShort: null,
        reasonForInsurance: null,
        waiver: null,
        selectedQuote: null,
        term: null,
        maxTerm: null,
        faceAmount: null,
        isRare: null,
        insuredAndOwnerAndPayer: null,
        applicationSignedDate: null,
        applicationSignedState: null,
        aUEffectiveDate: null,
        tLICEffectiveDate: null,
        effectiveDate: null,
        paymentFrequency: null,
        economicIncentive: null,
        beneficialInterest: null,
        beneficiaryChildrenEvenSplit: null,
        beneficiaryChildrenType: null,
        beneficiaryOtherParentName: null,
        beneficiaryPerStirpes: null,
        beneficiaryType: null,
        contingentBeneficiaryChildrenEvenSplit: null,
        contingentBeneficiaryChildrenType: null,
        contingentBeneficiaryOtherParentName: null,
        contingentBeneficiaryPerStirpes: null,
        contingentBeneficiaryType: null,
        hasContingentBeneficiary: null,
        primaryBeneficiary: [__assign({}, HitRequestBuilder.Beneficiary)],
        contingentBeneficiary: [__assign({}, HitRequestBuilder.Beneficiary)],
        hasEcp: null,
        personalReasonForInsurance: null,
        premiumSourceYesNoOther: null,
        isOwnerAlsoPayer: null,
        businessReasonForInsurance: null,
        policyBusinessPurpose: __assign({}, HitRequestBuilder.PolicyBusinessPurpose),
        notOnMilitaryAndForCollateral: null,
        collaterallyAssigned: null,
        collateralAssignment: __assign({}, HitRequestBuilder.CollateralAssignment),
        contingentOwnerType: null,
        contingentOwnerPerson: __assign({}, HitRequestBuilder.Person),
        premiumPayer: null,
        riders: [__assign({}, HitRequestBuilder.PolicyRider)],
        payer: __assign({}, HitRequestBuilder.PartyQuery),
        ownerClassification: null,
        isJointOwnerSomeoneElse: null,
        eliminationPeriod: null,
        monthlyBenefit: null,
        maximumClaimValue: null,
        minimumClaimValue: null,
        benefitPeriod: null,
        deathBenefit: null,
        isTelesalesAgent: null,
        isIndependentAdvisor: null
    };
    HitRequestBuilder.BaseQuote = {
        healthClass: null,
        invite: null
    };
    HitRequestBuilder.ApplicationResponseQuery = {
        policies: [__assign({}, HitRequestBuilder.Policy)],
        type: null,
        applicationNumber: '',
        createdTime: null,
        isAgentAssistant: null,
        quote: __assign({}, HitRequestBuilder.BaseQuote),
        isTeleCMI: null,
        teleCMILanguage: null,
        teleCMIModeOfContact: null,
        teleCMIBestTimeToCall: null,
        skipTLIC: null
    };
    HitRequestBuilder.CustomerIndication = {
        drugCode: null,
        name: null,
        code: null,
        details: null
    };
    //missed: selectedIndicatorsRatingCap
    HitRequestBuilder.RxSelectionResponseQuery = {
        noHitResponseFromCustomer: null,
        noHitCommentsFromCustomer: null,
        customerIndications: [__assign({}, HitRequestBuilder.CustomerIndication)]
    };
    HitRequestBuilder.RareSupplementsResponseQuery = {
        riskFactors: __assign({}, HitRequestBuilder.RiskFactors)
    };
    HitRequestBuilder.RareLongFormResponseQuery = {
        personalHistory: __assign({}, HitRequestBuilder.PersonalHistory),
        isPregnant: null
    };
    HitRequestBuilder.IdData = {
        firstName: null,
        middleName: null,
        lastName: null,
        dob: null,
        address: __assign({}, HitRequestBuilder.Address),
        verificationAddress: __assign({}, HitRequestBuilder.Address),
        SSN: null
    };
    HitRequestBuilder.FixIdDataResponseQuery = {
        insuredData: HitRequestBuilder.IdData,
        ownerData: HitRequestBuilder.IdData
    };
    HitRequestBuilder.FixMVRDataResponseQuery = {
        idNumber: null,
        idState: null,
        idExpires: null
    };
    HitRequestBuilder.CustomerInfoResponseQuery = {
        customerId: '',
        customerEmail: null,
        customerChannel: null,
        leadId: null
    };
    HitRequestBuilder.ExamVendorResponseQuery = {
        examVendor: null
    };
    HitRequestBuilder.PolicyDocData = {
        policyNumber: '',
        docType: null,
        doc: '',
        type: null,
        docSource: null,
        appType: null,
        subType: null,
        name: null,
        date: null,
        uploadedBy: null,
        language: null,
        roles: null,
        order: null,
        status: null
    };
    HitRequestBuilder.PolicyDocResponseQuery = {
        policyDocs: [__assign({}, HitRequestBuilder.PolicyDocData)]
    };
    HitRequestBuilder.DocuSignField = {
        tabId: '',
        tabLabel: null,
        status: null,
        value: null,
        selected: null
    };
    HitRequestBuilder.DocuSignTabs = {
        name: '',
        signHereTabs: [__assign({}, HitRequestBuilder.DocuSignField)],
        dateSignedTabs: [__assign({}, HitRequestBuilder.DocuSignField)],
        radioGroupTabs: [__assign({}, HitRequestBuilder.DocuSignField)],
        textTabs: [__assign({}, HitRequestBuilder.DocuSignField)],
        checkboxTabs: [__assign({}, HitRequestBuilder.DocuSignField)],
        listTabs: [__assign({}, HitRequestBuilder.DocuSignField)],
        tabGroups: [__assign({}, HitRequestBuilder.DocuSignField)]
    };
    HitRequestBuilder.DocuSignFormsTabResponseQuery = {
        forms: [__assign({}, HitRequestBuilder.DocuSignTabs)]
    };
    HitRequestBuilder.AgentDataObject = {
        agencyId: null,
        agencyName: null,
        producerId: null,
        licenseStatus: null,
        genericLink: null,
        businessUnit: null,
        type: null,
        ratio: null,
        renewalCommissionRatio: null,
        displayName: null,
        party: __assign({}, HitRequestBuilder.PartyQuery)
    };
    HitRequestBuilder.AgentResponseQuery = {
        policyNumber: '',
        agentDataObjects: [__assign({}, HitRequestBuilder.AgentDataObject)]
    };
    HitRequestBuilder.AppsAppointmentDataResponseQuery = {
        haveAppsCallClient: null,
        scheduledDateTime: null,
        preferredDateTime: null,
        examAddress: __assign({}, HitRequestBuilder.Address)
    };
    HitRequestBuilder.FlatExtra = {
        name: null,
        amount: null,
        premium: null
    };
    HitRequestBuilder.PremiumBreakdown = {
        rateClass: null,
        base: null,
        total: null,
        waiver: null,
        flatExtras: [__assign({}, HitRequestBuilder.FlatExtra)],
        flatExtrasTotal: null
    };
    HitRequestBuilder.PremiumInfo = {
        isTLIC: null,
        isAccelerated: null,
        acceleratedPremiumBreakdown: __assign({}, HitRequestBuilder.PremiumBreakdown),
        tLICPremiumBreakdown: __assign({}, HitRequestBuilder.PremiumBreakdown),
        issuedPremiumBreakdown: __assign({}, HitRequestBuilder.PremiumBreakdown),
        productPremiumVersion: null,
    };
    HitRequestBuilder.AgentDefaultCommissionSplit = {
        ratio: 0
    };
    HitRequestBuilder.AgentProfile = {
        examVendor: null
    };
    HitRequestBuilder.Agent = {
        party: __assign({}, HitRequestBuilder.PartyQuery),
        agencyId: null,
        agencyName: null,
        producerId: null,
        genericLink: null,
        group: null,
        producerAltCategory: null,
        agentDefaultCommissionSplits: [__assign({}, HitRequestBuilder.AgentDefaultCommissionSplit)],
        profile: __assign({}, HitRequestBuilder.AgentProfile)
    };
    HitRequestBuilder.PolicyAgent = {
        ratio: null,
        renewalCommissionRatio: null,
        type: null,
        agent: __assign({}, HitRequestBuilder.Agent)
    };
    HitRequestBuilder.Application = {
        isFrozen: null,
        applicationFormQsID: null,
        examVendor: null,
        quote: __assign({}, HitRequestBuilder.BaseQuote),
        isAgentAssistant: null,
        _id: null,
        isTeleCMI: null,
        teleCMILanguage: null,
        teleCMIModeOfContact: null,
        teleCMIBestTimeToCall: null,
        skipTLIC: null,
        applicationNumber: null
    };
    HitRequestBuilder.TelesalesSMSConsent = {
        eConsentTime: null,
        hipaaTime: null,
        mibTime: null,
        disclosureTime: null,
        smsPhoneNumber: null,
        smsConsentCode: null
    };
    //missed in use: 'onlineParamedSchedulingDate'?
    HitRequestBuilder.PolicyInfo = {
        owner: [__assign({}, HitRequestBuilder.PartyQuery)],
        insured: [__assign({}, HitRequestBuilder.Applicant)],
        policyNumber: null,
        customerId: null,
        type: null,
        carrier: null,
        product: null,
        productType: null,
        submittedLanguage: null,
        status: null,
        submittedAt: null,
        submittedFromIP: null,
        issuedDate: null,
        reasonForInsuranceShort: null,
        reasonForInsurance: null,
        waiver: null,
        selectedQuote: null,
        term: null,
        maxTerm: null,
        faceAmount: null,
        isRare: null,
        insuredAndOwnerAndPayer: null,
        applicationSignedDate: null,
        applicationSignedState: null,
        aUEffectiveDate: null,
        tLICEffectiveDate: null,
        effectiveDate: null,
        economicIncentive: null,
        paymentFrequency: null,
        beneficialInterest: null,
        beneficiaryChildrenEvenSplit: null,
        beneficiaryChildrenType: null,
        beneficiaryOtherParentName: null,
        beneficiaryPerStirpes: null,
        beneficiaryType: null,
        contingentBeneficiaryChildrenEvenSplit: null,
        contingentBeneficiaryChildrenType: null,
        contingentBeneficiaryOtherParentName: null,
        contingentBeneficiaryPerStirpes: null,
        contingentBeneficiaryType: null,
        hasContingentBeneficiary: null,
        primaryBeneficiary: [__assign({}, HitRequestBuilder.Beneficiary)],
        contingentBeneficiary: [__assign({}, HitRequestBuilder.Beneficiary)],
        riders: [__assign({}, HitRequestBuilder.PolicyRider)],
        includeAdbr: null,
        channel: null,
        tLICRateClass: null,
        finalRateClass: null,
        paramedScheduledDate: null,
        onlineParamedScheduledDate: null,
        application: __assign({}, HitRequestBuilder.Application),
        primaryPolicyAgent: __assign({}, HitRequestBuilder.PolicyAgent),
        additionalPolicyAgents: [__assign({}, HitRequestBuilder.PolicyAgent)],
        servicingPolicyAgent: __assign({}, HitRequestBuilder.PolicyAgent),
        secondaryAddressee: __assign({}, HitRequestBuilder.PartyQuery),
        collateralAssignment: __assign({}, HitRequestBuilder.CollateralAssignment),
        paymentAccountType: null,
        paymentAccount: null,
        paymentMode: null,
        paymentABA: null,
        paymentBankName: null,
        paymentCCCardType: null,
        workflowSubState: null,
        workflowState: null,
        workflowStageEntered: null,
        premiumInfo: __assign({}, HitRequestBuilder.PremiumInfo),
        payer: __assign({}, HitRequestBuilder.PartyQuery),
        trustOrOtherEntity: __assign({}, HitRequestBuilder.Entity),
        insuredIsJuvenile: null,
        canFreezePolicy: null,
        jointPolicy: __assign({}, HitRequestBuilder.JointPolicy),
        telesalesSMSConsent: __assign({}, HitRequestBuilder.TelesalesSMSConsent),
        isTelesalesAgent: null,
        canBackdateConvertedPolicy: null
    };
    HitRequestBuilder.PolicyInfoResponseQuery = {
        policy: __assign({}, HitRequestBuilder.PolicyInfo)
    };
    HitRequestBuilder.getDefaultQueryArg = {
        uwSetStatus: HitRequestBuilder.responseQuery,
        notifyUwStageUpdate: HitRequestBuilder.responseQuery,
        confirmSubmitFollowUp: HitRequestBuilder.responseQuery,
        applicationData: HitRequestBuilder.ApplicationResponseQuery,
        customerSelectedRxIndications: HitRequestBuilder.RxSelectionResponseQuery,
        rareSupplements: HitRequestBuilder.RareSupplementsResponseQuery,
        rareLongForm: HitRequestBuilder.RareLongFormResponseQuery,
        fixIdData: HitRequestBuilder.FixIdDataResponseQuery,
        fixMVRData: HitRequestBuilder.FixMVRDataResponseQuery,
        currentStage: { currentStage: null },
        customerInfo: HitRequestBuilder.CustomerInfoResponseQuery,
        policyDocAppsData: HitRequestBuilder.PolicyDocResponseQuery,
        examVendorData: HitRequestBuilder.ExamVendorResponseQuery,
        agentData: HitRequestBuilder.AgentResponseQuery,
        appsAppointmentData: HitRequestBuilder.AppsAppointmentDataResponseQuery,
        policyInfo: HitRequestBuilder.PolicyInfoResponseQuery,
        docuSignTabs: HitRequestBuilder.DocuSignFormsTabResponseQuery
    };
    HitRequestBuilder.setRequest /*: Record<Required<keyof HitGqlTypes.Query>, Function>*/ = {
        uwSetStatus: function (applicationId, msgCtx, status) {
            var req = {
                context: msgCtx,
                payload: {
                    applicationId: applicationId
                }
            };
            if (status) {
                Object.assign(req.payload, { status: status });
            }
            return req;
        },
        notifyUwStageUpdate: function (payload, msgCtx, msgGuid, publisherId, hostname) {
            var req = {
                context: msgCtx,
                payload: payload
            };
            if (msgGuid) {
                Object.assign(req, { msgGuid: msgGuid });
            }
            if (publisherId) {
                Object.assign(req, { publisherId: publisherId });
            }
            if (hostname) {
                Object.assign(req, { hostname: hostname });
            }
            return req;
        },
        confirmSubmitFollowUp: function (policyNumber, jwtToken) {
            return {
                policyNumber: policyNumber,
                jwtToken: jwtToken
            };
        },
        applicationData: function (applicationId) {
            return { applicationId: applicationId };
        },
        customerSelectedRxIndications: function (policyNumber) {
            return { policyNumber: policyNumber };
        },
        rareSupplements: function (policyNumber) {
            return { policyNumber: policyNumber };
        },
        rareLongForm: function (policyNumber) {
            return { policyNumber: policyNumber };
        },
        fixIdData: function (policyNumber) {
            return { policyNumber: policyNumber };
        },
        fixMVRData: function (policyNumber) {
            return { policyNumber: policyNumber };
        },
        currentStage: function (applicationId) {
            return { applicationId: applicationId };
        },
        customerInfo: function (applicationId) {
            return { applicationId: applicationId };
        },
        policyDocAppsData: function (policyNumber, policyDocDocTypes, policyDocAppTypes) {
            return {
                policyNumber: policyNumber,
                policyDocDocTypes: policyDocDocTypes,
                policyDocAppTypes: policyDocAppTypes
            };
        },
        examVendorData: function (applicationId) {
            return { applicationId: applicationId };
        },
        agentData: function (policyNumber) {
            return { policyNumber: policyNumber };
        },
        appsAppointmentData: function (policyNumber) {
            return { policyNumber: policyNumber };
        },
        policyInfo: function (channels, policyNumber, applicationId, policyType) {
            return {
                policyNumber: policyNumber,
                applicationId: applicationId,
                policyType: policyType,
                channels: channels
            };
        },
        docuSignTabs: function (policyNumber, forms) {
            return {
                policyNumber: policyNumber,
                forms: forms
            };
        }
    };
    HitRequestBuilder.getClientEndpoint /*: Record<Required<keyof HitGqlTypes.Query>, keyof HitApiClient>*/ = {
        uwSetStatus: 'setStatus',
        notifyUwStageUpdate: 'notifyUwStageUpdate',
        confirmSubmitFollowUp: 'confirmSubmitFollowUp',
        applicationData: 'getApplicationData',
        customerSelectedRxIndications: 'getRareCustomerSelectedRxIndications',
        rareSupplements: 'getRareSupplements',
        rareLongForm: 'getRareLongForm',
        fixIdData: 'getFixIdData',
        fixMVRData: 'getFixMVRData',
        currentStage: 'getCurrentStage',
        customerInfo: 'getCustomerInfo',
        policyDocAppsData: 'getPolicyDocAppsData',
        examVendorData: 'getExamVendor',
        agentData: 'getAgentData',
        appsAppointmentData: 'getAppsAppointmentData',
        policyInfo: 'getPolicyInfo',
        docuSignTabs: 'getDocuSignTabs'
    };
    return HitRequestBuilder;
}());
exports.HitRequestBuilder = HitRequestBuilder;
//# sourceMappingURL=HitRequestBuilder.js.map